<template>
  <div>
    <div
      v-if="tenantPermInfo.isDisabledInteract == 2"
      class="c-discuss-wrap"
      :class="{ hide: status }"
    >
      <div class="discuss-opea">
        <span @click="changeStatus" class="text">{{
          !status ? "收起评论" : "展开评论"
        }}</span>
        <span
          class="icon icontemp"
          @click="changeStatus"
          :class="{ 'up-b': !status, 'down-b': status }"
        ></span>
      </div>
      <ul class="discuss-tab" :class="{ hide: status }">
        <li
          :class="{
            active: type == '1',
            'new-message': interaction.unReadCount > 0
          }"
          @click="changeDiscussType('1')"
        >
          <a>互动问答</a>
        </li>
        <li
          :class="{ active: type == '2', 'new-message': mine.unReadCount > 0 }"
          @click="changeDiscussType('2')"
        >
          <a>我的提问</a>
        </li>
        <li
          :class="{
            active: type == '3',
            'new-message': conversation.unReadCount > 0
          }"
          @click="changeDiscussType('3')"
        >
          <a>我的私聊</a>
        </li>
        <img
          src="../../assets/images/top.png"
          class="top"
          alt=""
          v-if="interaction.topList.length > 0"
          @click="showTop(true)"
        />
      </ul>
      <div :class="{ 'no-show': status }">
        <div
          class="discuss-area"
          id="interaction"
          :class="{ 'have-ppt': pptIsOpen }"
        >
          <GeminiScrollbar
            ref="scroll"
            v-if="type == '1'"
            :autoshow="true"
            class="my-scroll-bar"
          >
            <div v-if="interaction.list.length > 0">
              <div v-for="(item, i) in interaction.list" :key="i">
                <div
                  class="c-speak-list"
                  v-if="
                    (item.from_user.role == '0' ||
                      item.from_user.role == '1') &&
                      item.refList.length == 0
                  "
                >
                  <div class="speak-user">
                    <div class="speak-avatar">
                      <img :src="item.from_user.avatar" alt="" />
                    </div>
                    <div class="speak-name">
                      {{
                        userInfo.applicantId == item.from_user.uid
                          ? "我"
                          : item.from_user.userName
                      }}
                    </div>
                    <div class="speak-time">
                      {{ item.updated_at }}
                    </div>
                  </div>
                  <div
                    class="speak-text"
                    v-html="replaceColon(item.content)"
                  ></div>
                </div>
                <div v-if="item.refList.length > 0">
                  <div v-for="(list, j) in item.refList" :key="j">
                    <div
                      class="c-speak-list admin"
                      v-if="
                        item.from_user.role == '2' || item.from_user.role == '1'
                      "
                    >
                      <div class="speak-user">
                        <div class="speak-avatar">
                          <span
                            class="icon icontemp administrator"
                            v-if="
                              item.from_user.avatar == '' ||
                                !item.from_user.avatar
                            "
                          ></span>
                          <img
                            :src="item.from_user.avatar"
                            alt=""
                            v-if="
                              item.from_user.avatar &&
                                item.from_user.avatar != ''
                            "
                          />
                        </div>

                        <div class="speak-name">
                          {{ item.from_user.userName }}回复了<span
                            class="user-name"
                          >
                            {{
                              userInfo.applicantId == item.to_user.uid
                                ? "我"
                                : item.to_user.userName
                            }}</span
                          >
                        </div>
                        <div class="speak-time">
                          {{ list.updated_at }}
                        </div>
                      </div>
                      <div
                        class="speak-text"
                        v-html="replaceColon(item.content)"
                      ></div>
                    </div>
                  </div>
                </div>
                <div v-if="item.refList.length == 0">
                  <div
                    class="c-speak-list admin"
                    v-if="item.from_user.role == '2'"
                  >
                    <div class="speak-user">
                      <div class="speak-avatar">
                        <span
                          class="icon icontemp administrator"
                          v-if="
                            item.from_user.avatar == '' ||
                              !item.from_user.avatar
                          "
                        ></span>
                        <img
                          :src="item.from_user.avatar"
                          alt=""
                          v-if="
                            item.from_user.avatar && item.from_user.avatar != ''
                          "
                        />
                      </div>

                      <div class="speak-name">
                        {{ item.from_user.userName }}
                      </div>
                      <div class="speak-time">
                        {{ item.updated_at }}
                      </div>
                    </div>
                    <div
                      class="speak-text"
                      v-html="replaceColon(item.content)"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="interaction.list.length == '0'" class="no-qa">
              <img :src="noQa" />
              <p>暂无问答</p>
            </div>
          </GeminiScrollbar>
          <GeminiScrollbar
            :autoshow="true"
            v-if="type == '2'"
            class="my-scroll-bar"
          >
            <div v-if="mine.list.length > 0">
              <div v-for="(item, i) in mine.list" :key="i">
                <div class="c-speak-list" v-if="item.from_user.role == '0'">
                  <div class="speak-user">
                    <div class="speak-avatar">
                      <img :src="item.from_user.avatar" alt="" />
                    </div>
                    <div class="speak-name">
                      {{
                        userInfo.applicantId == item.from_user.uid
                          ? "我"
                          : item.from_user.userName
                      }}
                    </div>
                    <div class="speak-time">
                      {{ item.updated_at }}
                    </div>
                  </div>
                  <div
                    class="speak-text"
                    v-html="replaceColon(item.content)"
                  ></div>
                </div>
                <div v-if="item.from_user.role != '0'">
                  <div
                    class="c-speak-list admin"
                    v-if="
                      item.from_user.role == '2' || item.from_user.role == '1'
                    "
                  >
                    <div class="speak-user">
                      <div class="speak-avatar">
                        <span
                          class="icon icontemp administrator"
                          v-if="
                            item.from_user.avatar == '' ||
                              !item.from_user.avatar
                          "
                        ></span>
                        <img
                          :src="item.from_user.avatar"
                          alt=""
                          v-if="
                            item.from_user.avatar && item.from_user.avatar != ''
                          "
                        />
                      </div>
                      <div class="speak-name">
                        {{ item.from_user.userName }}回复了<span
                          class="user-name"
                        >
                          {{
                            userInfo.applicantId == item.to_user.uid
                              ? "我"
                              : item.name
                          }}</span
                        >
                      </div>
                      <div class="speak-time">
                        {{ item.updated_at }}
                      </div>
                    </div>
                    <div
                      class="speak-text"
                      v-html="replaceColon(item.content)"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="mine.list.length == '0'" class="no-qa">
              <img :src="noQa" />
              <p>暂无问答</p>
            </div>
          </GeminiScrollbar>
          <GeminiScrollbar
            :autoshow="true"
            v-if="type == '3'"
            class="my-scroll-bar"
          >
            <div v-if="conversation.type == '0'">
              <div v-if="conversation.list.length > 0">
                <div v-for="(option, n) in conversation.list" :key="n">
                  <div class="c-speak-list">
                    <div class="speak-user">
                      <div class="speak-avatar">
                        <div class="admin">
                          <span
                            class="icon icontemp administrator"
                            v-if="
                              option.admin.avatar == '' || !option.admin.avatar
                            "
                          ></span>
                          <img
                            :src="option.admin.avatar"
                            alt=""
                            v-if="
                              option.admin.avatar && option.admin.avatar != ''
                            "
                          />
                        </div>
                      </div>
                      <div class="speak-name">
                        {{ option.admin.userName }}
                      </div>
                      <div class="speak-time">
                        {{ option.updated_at }}{{ conversation.unReadCount }}
                      </div>
                    </div>
                    <div class="text-content">
                      <div
                        class="speak-text"
                        @click="loadMessages(option)"
                        v-html="replaceColon(option.chat.content)"
                      ></div>
                      <span class="count" v-if="option.unReadCount > 0">{{
                        option.unReadCount
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="no-qa" v-if="conversation.list.length == 0">
                <img :src="noQa" alt="" />
                <p>暂无问答</p>
              </div>
            </div>
            <div v-if="conversation.type != '0'">
              <li class="conversationInfo">
                <span class="back" @click="backConversation">返回</span>
                <span>{{ conversation.currentAdminInfo.adminName }}</span>
              </li>
              <div
                v-for="(option1, m) in conversation.currentConversation"
                :key="m"
              >
                <div class="c-speak-list">
                  <div class="speak-user">
                    <div class="speak-avatar">
                      <img
                        :src="option1.from_user.avatar"
                        v-if="option1.from_user.role == '0'"
                        alt=""
                      />
                      <div class="admin" v-if="option1.from_user.role == '2'">
                        <span
                          class="icon icontemp administrator"
                          v-if="
                            option1.from_user.avatar == '' ||
                              !option1.from_user.avatar
                          "
                        ></span>
                        <img
                          :src="option1.from_user.avatar"
                          alt=""
                          v-if="
                            option1.from_user.avatar &&
                              option1.from_user.avatar != ''
                          "
                        />
                      </div>
                    </div>
                    <div class="speak-name">
                      {{
                        userInfo.uid == option1.from_user.uid
                          ? "我"
                          : option1.from_user.userName
                      }}
                    </div>
                    <div class="speak-time">
                      {{ option1.updated_at }}
                    </div>
                  </div>
                  <div
                    class="speak-text"
                    v-html="replaceColon(option1.content)"
                  ></div>
                </div>
              </div>
            </div>
          </GeminiScrollbar>
          <div class="top-qa" v-show="isShowTop">
            <div v-for="(item, i) in interaction.topList" :key="i">
              <div class="c-speak-list admin">
                <span class="icontemp clear" @click="showTop(false)"></span>
                <div class="speak-user">
                  <div
                    class="speak-avatar"
                    v-if="
                      item.from_user.role == '2' || item.from_user.role == '1'
                    "
                  >
                    <span
                      class="icon icontemp administrator"
                      v-if="
                        item.from_user.avatar == '' || !item.from_user.avatar
                      "
                    ></span>
                    <img
                      :src="item.from_user.avatar"
                      alt=""
                      v-if="
                        item.from_user.avatar && item.from_user.avatar != ''
                      "
                    />
                  </div>
                  <div class="speak-avatar" v-if="item.from_user.role === '0'">
                    <img :src="item.from_user.avatar || userImg" alt="" />
                  </div>
                  <div
                    class="speak-name"
                    v-if="
                      item.from_user.role == '2' || item.from_user.role == '1'
                    "
                  >
                    {{ item.from_user.userName
                    }}{{ item.to_user ? "回复了" : ""
                    }}<span class="user-name" v-if="item.to_user">
                      {{
                        userInfo.applicantId == item.to_user.uid
                          ? "我"
                          : item.to_user.userName
                      }}</span
                    >
                  </div>
                  <div class="speak-name" v-if="item.from_user.role === '0'">
                    <span class="user-name">
                      {{
                        userInfo.applicantId == item.from_user.uid
                          ? "我"
                          : item.from_user.userName
                      }}</span
                    >
                  </div>
                  <div class="speak-time">
                    <img src="../../assets/images/top.png" class="top" alt="" />
                    {{ item.updated_at }}
                  </div>
                </div>
                <div
                  class="speak-text"
                  v-html="replaceColon(item.content)"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="discuss-emit" :class="{ hide: status }">
        <Emoji ref="emoji" :isMobile="false" @change="getContent"></Emoji>
        <div class="emit-input">
          <!--<input type="text" class="input-text" />-->
          <div
            id="discuss-edit"
            class="input-text edit-able"
            placeholder="说两句..."
            contenteditable="true"
          ></div>
          <span class="icon icontemp smiley" @click="emoji()"></span>
          <div class="icon icontemp tupian" @click="selectFile">
            <input
              v-show="false"
              type="file"
              ref="localImage"
              @change="fileChange($event)"
              accept="image/gif,image/jpeg,image/jpg,image/png"
            />
          </div>
        </div>
        <div class="emit-send" @click="submit()">
          <span class="icon icontemp arrow-t"></span>
        </div>
      </div>
    </div>
    <div
      v-if="tenantPermInfo.isDisabledInteract == 1"
      class="no-qa-disabled"
      :class="{ 'no-qa-c': !pptIsOpen }"
    >
      <img :src="noQa" />
      <p>暂无问答</p>
    </div>
  </div>
</template>

<script>
import { $subscriber, ck, interact, cr } from "fire-wind-water";
import $ from "jquery";
import moment from "moment";
import Emoji from "../wap/Emoji";
import webinarService from "../../services/webinar";
import { replaceColon } from "../../common/emoji";
import { socketModule } from "../../common/socket";
import { mixinsTemplate } from "../../common/mixinsTemplate";

export default {
  name: "Discuss",
  mixins: [mixinsTemplate],
  components: { Emoji },
  data() {
    return {
      content: "",
      type: "1",
      status: false,
      pptIsOpen: false,
      userImg: require("../../assets/images/d-defaut.png"),
      noQa: require("../../assets/images/noQA.png"),
      firstUpdatedAt: "",
      userInfo: {},
      topQa: {},
      webinarInfo: {},
      isShowTop: true,

      interaction: {
        pageSize: 50,
        list: [],
        topList: [],
        unReadCount: 0,
        firstUpdatedAt: "",
        allTotal: 0
      },
      mine: {
        pageSize: 50,
        list: [],
        unReadCount: 0,
        firstUpdatedAt: "",
        allTotal: 0
      },
      conversation: {
        pageSize: 50,
        list: [],
        unReadCount: 0,
        type: 0,
        currentConversation: [],
        firstUpdatedAt: "",
        allTotal: 0,
        currentAdminInfo: {
          adminName: "",
          id: ""
        }
      },
      initType: false, //初始化状态值 防止初始化多次
      qaGagType: "tips" ////tips: 禁言提示,noTips: 禁言不提示 可以发送 别人看不到
    };
  },
  mounted() {
    let self = this;
    $("#interaction").scroll(function() {
      let scrollHeight = this.scrollHeight;
      let scrollTop = this.scrollTop;
      let clientHeight = this.clientHeight;
      if (scrollTop == "0") {
        if (self.interaction.list.length < self.interaction.allTotal) {
          self.loadInteractions();
        }
      }
      if (scrollTop + clientHeight == scrollHeight) {
      }
    });
    $("#mine").scroll(function() {
      let scrollHeight = this.scrollHeight;
      let scrollTop = this.scrollTop;
      let clientHeight = this.clientHeight;
      if (scrollTop == "0") {
        if (self.mine.list.length < self.mine.allTotal) {
          self.loadMines();
        }
      }
      if (scrollTop + clientHeight == scrollHeight) {
      }
    });

    $(".edit-able").keydown(function($event) {
      var keycode = window.event ? $event.keyCode : $event.which;
      var evt = $event || window.event;
      if (keycode == 13 && !evt.ctrlKey) {
        self.submit();
        setTimeout(() => {
          $(".edit-able")
            .children("div")
            .remove();
        }, 0);
      }
    });
  },
  created() {
    let _this = this;
    $subscriber.subscribe("webinarInfo", data => {
      this.webinarInfo = data;
    });
    $subscriber.on("userInfo", data => {
      this.userInfo = data;
      if (!this.initType) {
        this.init();
      }
    });
    $subscriber.subscribe("pptInfoChange", data => {
      let { pptIsOpen } = data;
      this.pptIsOpen = pptIsOpen;
    });
    $subscriber.subscribe("onQaTop", data => {
      _this.interaction.topList = [];
      if (!data.isTop) {
        //如果是取消置顶就清空
        _this.isShowTop = false;
      } else {
        cr.each(_this.interaction.list, item => {
          if (item._id == data.qaId) {
            _this.interaction.topList.push(item);
            _this.isShowTop = true;
          }
        });
      }
    });

    $subscriber.subscribe("onQaNewMsg", data => {
      if (data.refList.length > 0) {
        cr.each(data.refList, list => {
          list.updated_at = moment(new Date(list.updated_at).getTime()).format(
            "HH:mm:ss"
          );
        });
      }
      data.updated_at = moment(new Date(data.updated_at).getTime()).format(
        "HH:mm:ss"
      );
      if (data.isChecked) {
        if (this.userInfo.applicantId != data.from_user.uid) {
          _this.onQA(data);
        }
      } else {
        if (this.userInfo.applicantId != data.from_user.uid) {
          _this.remove(data);
        }
      }
    });
    $subscriber.subscribe("onChatNewMsg", data => {
      data.updated_at = moment(new Date(data.updated_at).getTime()).format(
        "HH:mm:ss"
      );
      _this.onChat(data);
    });
    $subscriber.subscribe("onQaDelete", data => {
      _this.remove(data);
    });
    $subscriber.subscribe("onGag", data => {
      if (_this.qaGagType == "tips") {
        if (data.isGag) {
          if (data.expires) {
            $subscriber.emit("showPopup", {
              message:
                "您已被管理员禁言，将在" +
                moment(new Date(data.expires).getTime()).format("HH:mm:ss") +
                " 解除"
            });
          } else {
            $subscriber.emit("showPopup", {
              message: "您已被管理员禁言"
            });
          }
        } else {
          $subscriber.emit("showPopup", { message: "您已解除禁言" });
        }
      }
    });
    //0: 无需审核, 1: 开启审核, 2: 禁言(单人禁言优先级大于集体禁言)
    $subscriber.subscribe("onAllGagStatus", data => {
      if (_this.qaGagType == "tips") {
        if (data.typeId == "0") {
          $subscriber.emit("showPopup", { message: "已经开启公共问答" });
        } else if (data.typeId == "1") {
          $subscriber.emit("showPopup", { message: "已开启发言审核" });
        } else {
          $subscriber.emit("showPopup", { message: "已开启全体禁言" });
        }
      }
    });
    //0: 禁言提示,1: 禁言不提示 可以发送 别人看不到
    $subscriber.subscribe("onAllGagType", data => {
      this.qaGagType = data.qaGagType;
    });
  },
  methods: {
    init() {
      this.initType = true;
      this.interaction.list = [];
      this.interaction.topList = [];
      this.mine.list = [];
      this.conversation.list = [];
      //预览页面不请求qa接口
      if (window.location.href.indexOf("isSetting") == -1) {
        this.loadInteractions();
        this.loadMines();
        this.loadConversations();
      }
    },
    replaceColon(text) {
      return replaceColon(text);
    },
    changeStatus() {
      this.status = !this.status;
    },
    changeDiscussType(type) {
      this.type = type;
      if (type == "1") {
        this.interaction.unReadCount = "0";
      } else if (type == "2") {
        this.mine.unReadCount = "0";
      } else {
        this.conversation.unReadCount = "0";
      }
      setTimeout(() => {
        $(".discuss-area .gm-scroll-view").animate({ scrollTop: 9999999 }, 0);
      }, 0);
    },
    //加载互动问答
    loadInteractions() {
      let self = this;
      webinarService
        .getQas({
          webinarId: this.webinarInfo.webinarId,
          page: 1,
          limit: this.interaction.pageSize,
          updated_at: this.interaction.firstUpdatedAt,
          uncheckuser: this.userInfo.id,
          sort: "updated_at",
          order: "desc"
        })
        .then(data => {
          cr.each(data.docs, item => {
            item.updated_at = moment(
              new Date(item.updated_at).getTime()
            ).format("HH:mm:ss");
            if (item.from_user.role == "0") {
              item.from_user.avatar = item.from_user.avatar
                ? item.from_user.avatar
                : this.userImg;
            }
            cr.each(item.refList, list => {
              list.updated_at = moment(
                new Date(list.updated_at).getTime()
              ).format("HH:mm:ss");
            });
            if (item.refList.length > 1) {
              let ar = [];
              ar.push(item.refList[item.refList.length - 1]);
              item.refList = ar;
            }
            // 管理员角色,发的消息是http://或https://开头的,转成链接
            if (
              item.from_user.role === "2" &&
              (item.content.trim().indexOf("http://") === 0 ||
                item.content.trim().indexOf("https://") === 0)
            ) {
              item.content = `<a href="${item.content.trim()}" target="_blank">${
                item.content
              }</a>`;
            }
            self.interaction.list.unshift(item);
          });
          cr.each(data.topDocs, item => {
            item.updated_at = moment(
              new Date(item.updated_at).getTime()
            ).format("HH:mm:ss");
            if (item.from_user.role == "0") {
              item.from_user.avatar = item.from_user.avatar
                ? item.from_user.avatar
                : this.userImg;
            }
            cr.each(item.refList, list => {
              list.updated_at = moment(
                new Date(list.updated_at).getTime()
              ).format("HH:mm:ss");
            });
            if (item.refList.length > 1) {
              let ar = [];
              ar.push(item.refList[item.refList.length - 1]);
              item.refList = ar;
            }
            self.interaction.topList.unshift(item);
          });
          if (self.interaction.topList.length > 0) {
            self.topQa = self.interaction.topList[0];
          }
          self.interaction.allTotal = data.total;
          if (data.total >= self.interaction.pageSize) {
            self.interaction.firstUpdatedAt =
              self.interaction.list[0].updated_at;
          } else {
            self.interaction.firstUpdatedAt = undefined;
          }

          setTimeout(() => {
            $(".discuss-area .gm-scroll-view").animate(
              {
                scrollTop: $(".discuss-area .gm-scroll-view").prop(
                  "scrollHeight"
                )
              },
              0
            );
          }, 0);
        });
    },
    loadMines() {
      webinarService
        .getQas({
          webinarId: this.webinarInfo.webinarId,
          page: 1,
          limit: this.mine.pageSize,
          updated_at: this.mine.firstUpdatedAt,
          user: this.userInfo.id,
          sort: "updated_at",
          order: "desc"
        })
        .then(data => {
          cr.each(data.docs, item => {
            item.updated_at = moment(
              new Date(item.updated_at).getTime()
            ).format("HH:mm:ss");
            if (item.from_user.role == "0") {
              item.from_user.avatar = item.from_user.avatar
                ? item.from_user.avatar
                : this.userImg;
            }
            cr.each(item.refList, list => {
              list.updated_at = moment(
                new Date(list.updated_at).getTime()
              ).format("HH:mm:ss");
            });
            if (item.refList.length > 1) {
              let ar = [];
              ar.push(item.refList[item.refList.length - 1]);
              item.refList = ar;
            }
            this.mine.list.unshift(item);
          });
          this.mine.allTotal = data.total;
          if (data.total >= this.mine.pageSize) {
            this.mine.firstUpdatedAt = this.interaction.list[0].updated_at;
          } else {
            this.mine.firstUpdatedAt = undefined;
          }
          //          $("#mine").animate({ scrollTop: $("#mine")[0].scrollHeight }, 800);
        });
    },
    //加载私聊列表
    loadConversations() {
      webinarService
        .getConversations({
          webinarId: this.webinarInfo.webinarId,
          page: 1,
          limit: this.conversation.pageSize,
          user: this.userInfo.id,
          sort: "updated_at",
          order: "desc"
        })
        .then(data => {
          cr.each(data, item => {
            item.updated_at = moment(
              new Date(item.updated_at).getTime()
            ).format("HH:mm:ss");
            item.unReadCount = 0;
            this.conversation.list.unshift(item);
          });
        });
    },
    ///获取私聊记录
    loadMessages(option) {
      let self = this;
      option.unReadCount = 0;
      this.conversation.currentConversation = [];
      this.conversation.type = "1";
      this.conversation.currentAdminInfo.adminName = option.admin.userName;
      this.conversation.currentAdminInfo.id = option.admin.uid;
      webinarService
        .getChats({
          webinarId: this.webinarInfo.webinarId,
          page: 1,
          limit: this.conversation.pageSize,
          from_user: option.user.uid,
          to_user: option.admin.uid,
          updated_at: this.conversation.firstUpdatedAt,
          sort: "updated_at",
          order: "desc"
        })
        .then(data => {
          cr.each(data.docs, item => {
            item.updated_at = moment(
              new Date(item.updated_at).getTime()
            ).format("HH:mm:ss");
            if (item.from_user.role == "0") {
              item.from_user.avatar = item.from_user.avatar
                ? item.from_user.avatar
                : this.userImg;
            }
            this.conversation.currentConversation.unshift(item);
          });
          //        if (data.total >= this.conversation.pageSize) {
          //        let time=data.updated_at
          //          this.conversation.firstUpdatedAt(this.conversation.updatedAt().format('yyyy-MM-dd hh:mm:ss'));
          //        } else {
          //          this.conversation.firstUpdatedAt(undefined);
          //        }
        });
    },
    //私聊详情回到详情列表
    backConversation() {
      this.conversation.type = "0";
      this.conversation.currentAdminInfo.adminName = "";
      this.conversation.currentAdminInfo.id = "";
      this.conversation.currentConversation = [];
    },
    emoji() {
      this.$refs.emoji.$emit("showEmoji");
    },
    selectFile() {
      this.$refs.localImage.click();
    },
    fileChange(e) {
      var _this = this;
      var files = e.target.files;
      if (files && files.length > 0) {
        var file = files[0];
        var fileType = file.type.toString();
        if (
          file.size > 10000 * 1024 ||
          (file.type.indexOf("png") < 0 &&
            file.type.indexOf("jpg") < 0 &&
            file.type.indexOf("jpeg") < 0 &&
            file.type.indexOf("gif") < 0)
        ) {
          $subscriber.emit(
            "error",
            "图片不能大于10M,必须是jpg,jpeg,png,gif格式"
          );
          this.$refs.localImage.value = "";
          return;
        }
        webinarService
          .upload({
            file: file
          })
          .subscribe(data => {
            if (data.result == 0) {
              var imgTag =
                '<img class="qa-img" src="' + data.content.newPath + '">';
              _this.submit(imgTag);
            } else {
              $subscriber.emit("error", data.desc);
            }
          });
      }
    },
    getContent(event) {
      this.content = event;
    },
    submit(imgTag = "") {
      let _this = this;
      //匿名用户是否允许提问
      if (
        this.webinarInfo.unLimit &&
        !this.webinarInfo.isAllowMessage &&
        !this.userInfo.isLogin &&
        (!this.userInfo.isRegistration ||
          (this.userInfo.isRegistration && this.userInfo.isUnLimit))
      ) {
        return $subscriber.emit("error", "很抱歉，匿名用户不允许提问！");
      }
      //匿名用户是否设置用户名
      var temporaryUserName = ck.cookie(
        "temporaryUserName_" + this.webinarInfo.webinarId
      );
      if (
        this.webinarInfo.unLimit &&
        this.webinarInfo.isSetUserName &&
        !temporaryUserName
      ) {
        if (
          !this.userInfo.isLogin &&
          (!this.userInfo.isRegistration ||
            (this.userInfo.isRegistration && this.userInfo.isUnLimit))
        ) {
          return $subscriber.emit("onUserNameShow");
        }
      }
      let data = {
        content: this.content ? this.content.replace(/(\r\n|\n|\r)/gm, "") : ""
      };
      if (imgTag) {
        data.content = imgTag;
      }
      if (!data.content) {
        return $subscriber.emit("error", "请填写内容！");
      }
      if (this.type == "3") {
        if (this.conversation.currentConversation.length == 0) {
          return $subscriber.emit("error", "没有私聊的对象！");
        }
        data.user = this.conversation.currentAdminInfo.id;

        socketModule.emit("onChatSubmit", data);
      } else {
        socketModule.emit("onQaSubmit", data, res => {
          if (res.code && res.code.toString() !== "0") {
            return $subscriber.emit("error", res.msg);
          }
          res.updated_at = moment(new Date(res.updated_at).getTime()).format(
            "HH:mm:ss"
          );
          this.onQA(res);
          this.mine.list.push(res);
          if (this.type != "2") {
            this.mine.unReadCount = this.mine.unReadCount + 1;
          }
        });
      }
      webinarService
        .liveSendmsg({
          browseInfo: interact.browseInfo,
          sess: this.userInfo.isLogin ? _this.userInfo.session : "",
          tenantId: _this.webinarInfo.tenantId,
          webinarId: _this.webinarInfo.webinarId,
          openId: 0,
          instanceId: _this.webinarInfo.instanceId,
          joinType: 1, //用户参会类型，1：登录用户 2：cookie用户 3：openId 4：其它用户（不支持）'
          globalUserId: ck.cookie("globalUserId")
        })
        .subscribe(() => {});
      this.$refs.emoji.clear();
      $(".edit-able").focus();
      //      setTimeout(() => {
      //        $(".discuss-area .gm-scroll-view").animate(
      //          {
      //            scrollTop: $(".discuss-area .gm-scroll-view").prop("scrollHeight")
      //          },
      //          800
      //        );
      //      }, 0);
    },
    onQA(qa) {
      //判断是否在底部
      let dom = $(".discuss-area .gm-scroll-view");
      let nDivHight = dom.height();
      let nScrollHight = dom[0].scrollHeight;
      let nScrollTop = dom[0].scrollTop;
      let needScroll =
        nScrollTop + nScrollTop >= nScrollHight ||
        qa.from_user.uid == this.userInfo.id;
      qa.from_user.avatar =
        qa.from_user.avatar || qa.from_user.role == "2"
          ? qa.from_user.avatar
          : this.userImg;
      if (qa.refList.length > 1) {
        let ar = [];
        ar.push(qa.refList[qa.refList.length - 1]);
        qa.refList = ar;
      }
      // 管理员角色,发的消息是http://或https://开头的,转成链接
      if (
        qa.from_user.role === "2" &&
        (qa.content.trim().indexOf("http://") === 0 ||
          qa.content.trim().indexOf("https://") === 0)
      ) {
        qa.content = `<a href="${qa.content.trim()}" target="_blank">${
          qa.content
        }</a>`;
      }
      this.interaction.list.push(qa);
      $subscriber.emit("onQAGet", qa);
      if (this.type != "1") {
        this.interaction.unReadCount = this.interaction.unReadCount + 1;
      }
      if (qa.to_user && qa.to_user.uid == this.userInfo.id) {
        this.mine.list.push(qa);

        if (this.type != "2") {
          this.mine.unReadCount = this.mine.unReadCount + 1;
        }
      }
      if (this.type && needScroll) {
        setTimeout(() => {
          $(".discuss-area .gm-scroll-view").animate(
            {
              scrollTop: $(".discuss-area .gm-scroll-view").prop("scrollHeight")
            },
            300
          );
        }, 0);
      }
    },
    remove(qa) {
      let idex = 0;
      cr.each(this.interaction.list, (item, index) => {
        if (item._id == qa._id) {
          idex = index;
        }
      });
      this.interaction.list.splice(idex, 1);
    },
    onChat(qa) {
      let self = this;
      // role  0 是用户 1好像是组织者  2是管理员
      let adminInfo = qa.from_user.role == "2" ? qa.from_user : qa.to_user;
      if (qa.from_user.role == "0") {
        qa.from_user.avatar = qa.from_user.avatar
          ? qa.from_user.avatar
          : this.userImg;
      }
      if (this.type != "3") {
        this.conversation.unReadCount = this.conversation.unReadCount + 1;
      }
      if (qa.from_user.role == "2") {
        qa.admin = qa.from_user;
        qa.user = qa.to_user;
        let chat = {
          content: qa.content
        };
        qa.chat = chat;
      } else {
        let chat = {
          content: qa.content
        };
        qa.admin = qa.to_user;
        qa.user = qa.from_user;
        qa.chat = chat;
      }
      if (this.conversation.list.length == "0") {
        qa.unReadCount = 1;
        this.conversation.list.unshift(qa);
      } else {
        ///  判断是否存在这个id 如果有那么就添加 因为有不同的角色
        var hasThisNew = false;
        cr.each(this.conversation.list, item => {
          if (item.admin.id == adminInfo.id) {
            hasThisNew = true;
          }
        });
        if (!hasThisNew) {
          qa.unReadCount = 1;
          this.conversation.list.unshift(qa);
        } else {
          cr.each(this.conversation.list, item => {
            if (item.admin.id == adminInfo.id) {
              item.chat.content = qa.content;
            }
            if (
              self.conversation.currentConversation.length == "0" &&
              item.admin.id == adminInfo.id
            ) {
              item.unReadCount += 1;
            }
            if (
              self.conversation.currentConversation.length != "0" &&
              this.conversation.currentConversation[0].admin.id == adminInfo.id
            ) {
              this.conversation.currentConversation.push(qa);
            }
          });
        }
      }
    },
    showTop(isShow) {
      this.isShowTop = isShow;
    }
  },
  beforeDestroy() {
    console.log("QA 销毁之前出发了");
  }
};
</script>

<style scoped></style>
